import React from 'react';
import './ProductsHero.css';

const ProductsHero = () => {
    return (
        <section className="products-hero-section">
            <div className="products-hero-content">
                <h1 className="products-hero-title">
                    Advanced Physiotherapy<br />
                    Equipment
                </h1>
            </div>
        </section>
    );
};

export default ProductsHero;
